import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=9bc408ee&"
import script from "./SidebarMobile.vue?vue&type=script&lang=js&"
export * from "./SidebarMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports